import { lazy, useEffect, useState } from "react";
import Axios from '../../helper/appConfig'
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import "./dashboard.css";
import DynamicTable from "../../components/DynamicTable";
import swal from "sweetalert";
import Receipt from "../../components/Receipt";
import Spinner from "../../components/Spinner";

export default function Dashboard(data) {
  console.log('data::: ', data);
  const location = useLocation();
  let branchFullName = data?.setLandingData?.branchname
  let logo = data?.setLandingData?.logo
  let locale = localStorage.getItem("Locale");
  let currency = localStorage.getItem("Currency");
  let LoginAuth = localStorage.getItem("LoginAuth");
  const compName = localStorage.getItem("CompanyName");
  const customerId = localStorage.getItem("LoginUserId");
  const onModel = localStorage.getItem("LoginUserType");

  // console.log("location::: ", location.state);
  const historyTypes = ["Bookings"];

  const [isLoader, setLoader] = useState(false);
  const [bookingList, setBookingList] = useState([]);
  const [allbookingList, setAllBookingList] = useState([]);
  const [pastbookingList, setpastBookingList] = useState([]);
  const [upcomingbookingList, setupcomingBookingList] = useState([]);
  const [tab, setTab] = useState(historyTypes[0]);
  const [reciept, setReciept] = useState(null);

  const upcomingHeaders = [
    "Object",
    "Booking ID",
    "Sr no.",
    "Document",
    "Service",
    "Service date",
    "Booking date",
    "Amount",
    "Booking Status",
    "Bill Status",
    "Action",
  ];

  const eventHistoryHeaders = [
    "Object",
    "Booking ID",
    "Sr no.",
    "Document",
    "Event Name",
    "Amount",
    "Event Date",
    "Booked Date",
    "Status",
    "Action",
  ];
  const setArray = (bookings) => {
    let arrays = [];
    bookings.forEach((ele, i) => {
      arrays[i] = [];
      arrays[i].push(ele);
      arrays[i].push(ele?.bookingid);
      arrays[i].push(i + 1);
      arrays[i].push(ele.appointmentnumber);
      arrays[i].push(ele.name ? ele.name : ele.title);
      arrays[i].push(new Date(ele?.appointmentdate ? ele?.appointmentdate : ele?.bookingdate).toLocaleDateString("en-IN")); // loginbranch locale should pass here
      arrays[i].push(ele?.bookingtype == "facilitybooking" ?  new Date(ele.createdAt).toLocaleDateString("en-IN") : new Date(ele.bookingdate).toLocaleDateString("en-IN")); ;
       // loginbranch locale should pass here
      // arrays[i].push(ele?.type === "Service" ? ele?.charges : ele.billtotalamount);
      arrays[i].push(
        // (ele.status === "requested" ||
        //   ele.status === "confirmed" ||
        //   ele.status === "cancel") ||
        //   (ele.billnumber === null)
          // ?
          ele?.charges
          // : ele.billtotalamount
      );

      // arrays[i].push(ele.hostname);
      arrays[i].push(ele.status);
      arrays[i].push(
        // (ele.status === "requested" ||
        //   ele.status === "confirmed" ||
        //   ele.status === "cancel") ||
        //   (ele.billnumber === null)
        //   ? "Unpaid"
          // :
          ele.bill?.status
      );
    });
    return arrays;
  };

  const generatePDF = () => {
    const printContent = document.getElementById("printrecipt");
    const WindowPrt = window.open();
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  };

  useEffect(() => {
    const loadData = async () => {
      setLoader(true);
      setpastBookingList([]);
      setupcomingBookingList([]);

      if (tab !== "Events") {
        await dashboardBookingLoadedData();
      } else {
        await dashboardEventLoadedData();
      }
    };
    loadData();
  }, [tab]);

  // async function getBookings() {
  //   let payload = {
  //     viewname: "bookingviews",
  //     formname: "member",
  //     search: [
  //       {
  //         searchfield: "customerid",
  //         searchvalue: localStorage.getItem("LoginUserId"),
  //         criteria: "eq",
  //         datatype: "objectid",
  //       },
  //     ],
  //   };
  //   let history = await commonService.commonPOSTMethod(
  //     "appointments/filter",
  //     payload
  //   );
  //   return history.data;
  // }


  async function getBookings() {
    let payload = {
      "id": "67494ce807038f2af1cf5deb",
      "search": [
          {
              "searchfield": "memberid",
              "searchvalue": customerId,
              "datatype": "ObjectId",
              "criteria": "eq"
          }
      ]
  }
    let history = await Axios.post(
      "analyticsreports/process",
      payload
    );
    return history.data;
  }

  async function getEventbills() {
    let payload = {
      search: [
        {
          searchfield: "status",
          searchvalue: "deleted",
          criteria: "ne",
          datatype: "text",
        },
        {
          searchfield: "eventid",
          searchvalue: true,
          criteria: "exists",
          datatype: "boolean",
        },
        {
          searchfield: "customerid",
          searchvalue: localStorage.getItem("LoginUserId"),
          criteria: "eq",
          datatype: "objectid",
        },
      ],
      // "viewname": "event-billviews"
    };
    const bills = await Axios.post("api/bills/filter", payload);
    return bills.data;
  }

  async function dashboardEventLoadedData() {
    let arrays = [];

    const bookings = await getEventbills();
    setAllBookingList(bookings);
    bookings.forEach((ele, i) => {
      arrays[i] = [];
      arrays[i].push(ele);
      arrays[i].push(ele?.bookingid);
      arrays[i].push(i + 1);
      arrays[i].push(ele?.docnumber);
      arrays[i].push(ele?.eventid?.title ? ele?.eventid?.title : "-");
      arrays[i].push(ele?.totalamount);
      arrays[i].push(
        new Date(ele?.eventid?.property?.startdate).toLocaleDateString("en-IN")
      );
      arrays[i].push(new Date(ele?.billdate).toLocaleDateString("en-IN")); // loginbranch locale should pass here
      arrays[i].push(ele?.status);
    });
    setBookingList(arrays);
    setLoader(false);
  }

  async function dashboardBookingLoadedData() {
    const bookings = await getBookings();
    let filterUnpaidData = bookings
    // console.log('filterUnpaidData::: ', filterUnpaidData);
    setAllBookingList(filterUnpaidData);
    let withoutDeletedBooking = filterUnpaidData?.filter((item) => item?.status !== "deleted")
    let withoutEventData = withoutDeletedBooking?.filter((item) => !item?.event)

    setpastBookingList(
      setArray(
        withoutEventData?.filter((a) =>
          moment(a?.appointmentdate ? a?.appointmentdate : a?.bookingdate).isBefore(
            moment(new Date()).subtract(1, "days").format()
          )
        )
      )
    );
    setupcomingBookingList(
      setArray(
        withoutEventData
          ?.filter((a) =>
            moment(a.appointmentdate ? a?.appointmentdate : a?.bookingdate).isAfter(
              moment(new Date()).subtract(1, "days").format()
            )
          )
          .sort((a, b) => moment(b?.appointmentdate ? b?.appointmentdate : b?.bookingdate) - moment(a?.appointmentdate ? a?.appointmentdate : a?.bookingdate))
      )
    );
    setLoader(false);
  }


  async function getBillCalculation(billData) {
    console.log('billData::: ', billData);

    return
    // const couponValue = coupondata?.value ?? 0;
    const finalTotalCost = billData?.charges
    const currentDate = new Date();
    // const couponVal = AppliedCoupon?.property?.value;
    // const discountAmount = (+service.charges * couponVal) / 100;
    // try {
    //     const priceAfterDiscount = +service.charges - discountAmount;
    // const payload = {
    //   customerid: customerId,
    //   onModel: onModel,
    //   billdate: currentDate,
    //   property: {},
    //   type: "pos",
    //   // status: "Unpaid",
    //   totalamount:
    //     (serviceFinalDetails && serviceFinalDetails?.grandTotal) || 0,
    //   services: [
    //     {
    //       couponcode: coupondata[0] || null,
    //       coupondiscount:
    //         AppliedCoupon?.coupontype === "Percentage"
    //           ? discountAmount
    //           : couponVal,
    //       discount: 0,
    //       finalcoupondiscount: couponValue,
    //       finaltotalcost: finalTotalCost,
    //       onModel: onModel,
    //       refid: service,
    //       quantity: 1,
    //       bookingdate: currentDate,
    //       charges: +service.charges,
    //       cost: +service.charges,
    //       totalcost: serviceFinalDetails?.grandTotal || +service.charges,
    //       taxes: service.taxes,
    //       status: "confirmed",
    //       duration: +service.duration,
    //       title: service.title,
    //     },
      // ],
    // };
    // setBillDetailsPayload(payload);

    // return await commonService.commonPOSTMethod("bills/billdetail", payload);
    // } catch (error) {
    //   console.error('error::: ', error);
    // }
  }


  async function getAppointment(bookId) {
    let body = {
      search: [
        {
          searchfield: "_id",
          searchvalue: bookId,
          criteria: "eq",
          datatype: "ObjectId",
        },
        {
          searchfield: "status",
          searchvalue: ["deleted"],
          criteria: "nin",
          datatype: "text",
        },
      ],
    };

    const bills = await Axios.post("api/appointments/filter", body);
    return bills.data;
  }


  async function billCount(data,type){
    // console.log('type::: ', type);
    // console.log('data::: ', data);

    let bookId = data[0]?.bookingid
    try {
      setLoader(true)

      const data = await getAppointment(bookId)

      const billData = await getBillCalculation(data)
      // console.log('billData::: ', billData);

    } catch (error) {
      setLoader(false)
      console.error('error::: ', error);

    }finally{
      setLoader(false)
    }



  }

  function handleCommonPayNow(data, type) {

    // billCount(data,type)

    // return

    // console.log('objectData::: ', objectData);
    // if(objectData?.type === "Service" &  objectData?.type === "Service" || type === 'past'){
    // }
    let objectData = data[0];
    if (objectData?.billnumber === null) {
      toast.error("Something went wrong.",{
        autoClose: 1500,
      });
      return;
    }

    let booking, id;
    if (type === "upcoming" || type === "past") {
      booking = allbookingList.find(
        (a) => a.appointmentnumber === objectData?.appointmentnumber
      );
      id = booking.billid;
    } else if (type === "event") {
      booking = allbookingList.find(
        (a) => a.docnumber === objectData?.docnumber
      );
      id = booking._id;
    } else {
    }
    if (!id) return;
    window.open(
      `${process.env.REACT_APP_PAYMENT_URL}/#/payment-prev?billid=${id}&https=true&domain=${process.env.REACT_APP_DEFAULT_API_URL}`,
      "_blank",
      "noreferrer"
    );
  }

  function handleUpcomingViewReceipt(data) {


    // return
    let receipt = allbookingList?.find((a) => a?.appointmentnumber === data[0]?.appointmentnumber);

    if (!receipt) {
      receipt = allbookingList?.find((a) => a?.docnumber === data[0]?.appointmentnumber);
    }
    console.log('receipt::: ', receipt);

    if (receipt?.eventid?._id) {
      setReciept({
        branchname: receipt?.eventid?.branchid?.branchname,
        name: receipt?.eventid?.name,
        date: receipt?.eventid?.property?.startdate,
        billnumber: receipt?.billnumber,
        billid: receipt?.property?.billid,
        billstatus: receipt?.status,
        // attendeename: receipt?.attendeename,
        eventTitle: receipt?.eventid?.title,
        branchaddress: receipt?.eventid?.branchaddress,
        branchid: receipt?.eventid?.branchid?._id,
        branchlogo: receipt?.eventid?.branchid?.branchlogo,
        branchqr: receipt?.eventid?.branchid?.qrcode,
        charges: receipt?.paidamount,
        endtime: receipt?.eventid?.property?.endtime,
        starttime: receipt?.eventid?.property?.starttime,
        type: receipt?.type,
      });
    } else {
      setReciept({
        branchname: receipt?.branchname ? receipt?.branchname : compName,
        name: receipt?.name ? receipt?.name : receipt?.host?.fullname,
        date: receipt?.bookingdate ? receipt?.bookingdate : "-",
        attendeename: receipt?.attendeename ? receipt?.attendeename : receipt?.branchFullName,
        billnumber: receipt?.billnumber ? receipt?.billnumber : "-",
        billid: receipt?.billid ? receipt?.billid : "-",
        billstatus: receipt?.billstatus ? receipt?.billstatus : receipt?.bill?.status,
        branchaddress: receipt?.branchaddress,
        branchid: receipt?.branchid,
        branchlogo: receipt?.branchlogo ? receipt?.branchlogo : logo,
        branchqr: receipt?.branchqr,
        charges: receipt?.charges,
        endtime: receipt?.endtime,
        starttime: receipt?.starttime,
        type: receipt?.type,
      });
    }

    setTimeout(() => {
      generatePDF();
    }, 1000);
  }

  async function handleCheckIn(data, type) {
    let clickBookingID = data[0];

    try {
      // const multiApiData = await getBookings();
      // const bookingData = multiApiData.filter((item) => item.bookingid === clickBookingID)
      // console.log('bookingData::: ', bookingData);

      let payload = {
        status: "checkout",
      };

      const appointment = await Axios.patch(
        `api/appointments/${clickBookingID}`,
        payload
      );

      // window.open(
      //   `${process.env.REACT_APP_PAYMENT_URL}/#/payment-prev?billid=${bill}&https=true&domain=${process.env.REACT_APP_DEFAULT_API_URL}`,
      //   "_blank",
      //   "noreferrer"
      // );
    } catch (error) {
      console.error("error::: ", error);
    }
  }

  // function handlePastPayNow() {
  //   let booking, id;
  //   if(type === 'upcoming' || type === 'past'){
  //     booking = allbookingList.find(a=>a.appointmentnumber ===  data[0]);
  //     id = booking.billid;
  //   }else if(type === 'event'){
  //     booking = allbookingList.find(a=>a.docnumber ===  data[0]);
  //     id = booking._id;
  //   }else{

  //   }
  //   if(!id)return;
  //   window.open(
  //       `${process.env.REACT_APP_PAYMENT_URL}/#/payment-prev?billid=${id}&https=true&domain=${process.env.REACT_APP_DEFAULT_API_URL}`,
  //       "_blank",
  //       "noreferrer"
  //   );
  // }

  const handleCancelClick = async (appointmentid, type) => {
    let clickBookingID = appointmentid[0];
    const givenDate = new Date(clickBookingID?.bookingdate);
    const currentDate = new Date();

    const differenceInMillis = currentDate - givenDate;
    const differenceInHours = differenceInMillis / (1000 * 60 * 60);

    if (differenceInHours <= 24) {
      if (
        (clickBookingID?.status === "requested" ||
          clickBookingID?.status === "confirmed") &&
        clickBookingID?.bookingid &&
        clickBookingID?.billid === undefined
      ) {
        swal({
          title: "Are you sure?",
          text: "Are you sure that you would like to cancel the following appointment",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (result) => {
          if (result) {
            try {
              setLoader(true);

              const payload = {
                status: "cancel",
                property: { cancellation: "Duplicate" },
              };

              let res;

              if (type === "Facility") {
                res = await Axios.patch(
                  `api/facilitybookings/${clickBookingID?.bookingid}`,
                  payload
                );
              } else {
                res = await Axios.patch(
                  `api/appointments/${clickBookingID?.bookingid}`,
                  payload
                );
              }

              if (
                res.data != null &&
                res.data != "undefind" &&
                res.status === 200
              ) {
                await dashboardBookingLoadedData();
                setLoader(false);
              }
            } catch (error) {
              setLoader(false);
              console.error("error::: ", error);
            }

            // navigate(0);
          }
        });
        // setRefreshKey((oldKey) => oldKey + 1);
        setLoader(false);
        //return response.data;
      } else {
        toast.error("Something went wrong", {
          autoClose: 1500,
        });
      }

    } else {
      toast.error(
        "You can cancel within 24 hours. After 24 hours, cancellations are not allowed",{
          autoClose: 1500,
        }
      );
    }
  };

  return (
    <>
      {isLoader && <Spinner />}
      <section className="common-block pt-4 pb-3">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12 col-lg-12">
              <ul
                className="nav nav-pills mb-2 categories-pills"
                id="pills-tab"
                role="tablist"
              >
                {historyTypes?.map((histr, i) => {
                  return (
                    <li className="nav-item" role="presentation" key={i}>
                      <a
                        className={`nav-link ${
                          histr === tab ? "active active_tab" : ""
                        }`}
                        data-toggle="pill"
                        href="#pills-item-2"
                        role="tab"
                        aria-controls="pills-item-2"
                        onClick={() => {
                          setTab(histr);
                        }}
                      >
                        {histr}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {tab === "Bookings" &&
          (
            <div className="min-vh-100">
              <div
                className="tab-pane fade show active"
                id="pills-item-1"
                role="tabpanel"
                aria-labelledby="pills-item-1-tab"
              >
                <h4 className="card-title mt-4 mb-4">Upcoming Bookings</h4>
                <div className="table-responsive">
                  <DynamicTable
                    tableHeaders={upcomingHeaders}
                    tableData={upcomingbookingList}
                    allbookingList={allbookingList}
                    type="upcoming"
                    onClickPayNow={handleCommonPayNow}
                    onClickViewReceipt={handleUpcomingViewReceipt}
                    onClickCancelBtn={handleCancelClick}
                    onClickCheckIn={handleCheckIn}
                  />
                </div>
              </div>

              <div
                className="tab-pane fade show active"
                id="pills-item-1"
                role="tabpanel"
                aria-labelledby="pills-item-1-tab"
              >
                <h4 className="card-title mt-4 mb-4">Past Bookings</h4>
                <div className="table-responsive">
                  <DynamicTable
                    tableHeaders={upcomingHeaders}
                    tableData={pastbookingList}
                    allbookingList={allbookingList}
                    type="past"
                    onClickPayNow={handleCommonPayNow}
                    onClickViewReceipt={handleUpcomingViewReceipt}
                    onClickCancelBtn={handleCancelClick}
                    onClickCheckIn={handleCheckIn}
                  />
                </div>
              </div>
            </div>
          )}

        </div>
      </section>

      <div style={{ display: "none" }} id="printrecipt">
        {reciept !== null ? <Receipt data={reciept} /> : ""}
      </div>
    </>
  );
}
